<template>
<div class="main courseitem">
  <!-- <van-swipe v-if="banners" class="swipe" :autoplay="3000">
    <van-swipe-item v-for="(img,index) in banners" :key="index">
      <video v-if="img.mime == 'mp4'" controls preload="auto" :poster="img.cover">
          <source :src="img.url" type="video/mp4">
          您的浏览器不支持 HTML5 视频,请更换浏览器。比如 Chrome 、 Firefox 等主流浏览器。
      </video>
      <img v-else v-lazy="img.url">
    </van-swipe-item>
  </van-swipe> --> 
  
  <div class="swipe">
    <van-swipe class="swipe" :autoplay="3000">
      <van-swipe-item>
        <img v-lazy="courseInfo.picture">
      </van-swipe-item>
    </van-swipe>
    <upload-file
      class="uploadBtn"
      :id="'upCover'"
      @callBackImgUrl="getCoverUrl"></upload-file>
    <van-button class="uploadBtn" type="primary" size="normal">上传封面</van-button>
  </div>
  <div class="bcw course-info">
    <header class="course-info__head">
      <h3>
          <input class="inputbox" type="text" v-model="courseInfo.title" style="width:100%;padding:.05rem">
      </h3>
      <div class="clear mtm mbm">
        <div class="clear left fs1 course-info__evaluate">
          <van-rate class="left" v-model="courseInfo.rating" :size="14" disabled-color="#FF6F0F" disabled />
          <span class="c9">评价{{ courseInfo.ratingNum }}</span>
          <!-- <span class="c9">参课{{ courseInfo.studentNum }}人</span> -->
        </div>
        <div class="right c6 fs2">
          <span class="course-info__price"><input class="inputbox" type="number" v-model="courseInfo.price" style="width:80px;"></span>/ 人·{{ courseInfo.courseTimes }}课时
        </div>
      </div>
    </header>

    <div class="clear ptm pbm course-info__enrolled">
      <div class="left fs2 c6">已报名 {{ courseInfo.studentNum }}/{{ courseInfo.maxStudentNum }}</div>
      <div @click="showStu=true" class="right course-info__users">
        <div class="course-info__avatar" v-for="(pic,index) in userPics" :key="index">
          <img v-if="pic" v-lazy="pic">
          <i v-else class="iconfont">&#xe6a7;</i>
        </div>
        <div v-if="userPics.length>0" class="course-info__avatar"><i class="iconfont">&#xeef4;</i></div>
      </div>
    </div>

    <div class="clear ptm pbm course-info__enrolled">
      <div class="left fs2 c6">已预约 {{ courseInfo.queueStudentNum }}
          <van-button type="primary" size="small" class="mln" @click="openSmallClass()">开小班</van-button>
      </div>
      <div @click="showQue=true" class="right course-info__users">
        <div class="course-info__avatar" v-for="(pic,index) in queueUserPics" :key="index">
          <img v-if="pic" v-lazy="pic">
          <i v-else class="iconfont">&#xe6a7;</i>
        </div>
        <div v-if="queueUserPics.length>0" class="course-info__avatar"><i class="iconfont">&#xeef4;</i></div>
      </div>
    </div>

    <footer class="mtm course-info__foot fs2">
      <div class="clear ptm pbm course-info__enrolled">
        <van-row>
          <van-col span="6">开课时间</van-col>
          <van-col span="18">
            <span v-if="courseInfo.startTime" @click="timePopupShow=true">{{ courseInfo.startTime}}&nbsp;&nbsp;&nbsp;</span>
            <span class="green" @click="timePopupShow=true">选择时间 &gt;</span>
          </van-col>
        </van-row>
        <van-row class="mtm address">
          <van-col span="6">上课地点</van-col>
          <van-col span="16"> 
            <router-link :to="{ name: 'venue',params:{clubId:clubInfo.id}}" class="clear mtm"><div class="fs2 mbn blue">{{ clubInfo.title }}</div> </router-link>
            <span class="fs2 c6">{{ clubInfo.address }}</span> 
          </van-col>
            <a :href="mapUrl" class="map c6"><i class="iconfont">&#xe635;</i></a>
        </van-row>
      </div>
      
      <div class="clear ptm pbm course-info__enrolled">
        <van-row>
          <van-col span="6">课程类型</van-col>
            <van-col span="18">
              <van-radio-group class="radioinline" v-model="courseInfo.type">
                  <van-radio name="1">单次团课</van-radio>
                  <van-radio name="2">周期性团课</van-radio>
              </van-radio-group>
            </van-col>                        
        </van-row>
        <van-row class="mtm fs2">
          <van-col span="6">持续周数</van-col>
          <van-col span="10">
            <input
              class="inputbox"
              type="number"
              placeholder="周数"
              v-model="courseInfo.weekNum"
              style="width:100%;padding:.03rem .05rem"
            >
          </van-col>
        </van-row>
        <van-row class="mtm">
          <van-col span="24">上课时间选择</van-col>
          <van-col span="24" class="fs1 c9 mtn">
            <span class="green">●</span>上课时间
            <span class="c9">●</span>非上课时间 &nbsp;点击进度条进行编辑
          </van-col>
          <div class="clear"></div>
          <van-col span="24" id="classTimeBox">
            <div class="datouwang" id="classTime">              
            </div>
          </van-col>                    
        </van-row>
      </div>
    </footer>
  </div>

  <div class="model-box mtm bcw">
    <div class="model-box__hd clear">
      <h3 class="left">教练信息</h3>
    </div>
    <van-row class="model-box__bd fs2 c6 mtm clear">
      <van-col span="18">
        <coach-card :coachInfo="coachInfo"></coach-card>
      </van-col>
      <van-col span="6" class="green mtw">
          <van-button type="primary" size="small" class="right" @click="showCoach = true">选择教练</van-button>
      </van-col>
    </van-row>    
  </div>

  <div class="model-box mtm bcw">
    <div class="model-box__hd clear">
      <h3 class="left">课程信息</h3>
    </div>
    <textarea class="inputbox fs2 mtm" rows="6" placeholder="内容信息" v-model="courseInfo.about"  style="width:100%;padding:.05rem;"></textarea>
  </div>

  <div class="model-box mtm bcw">
    <div class="model-box__hd clear">
      <h3 class="left">学员评价</h3>
    </div>
    <div class="model-box__bd fs2 c6 mtm clear">
      <evaluate-card v-for="item in reviewList" :iteminfo="item" :key="item.id" :type="'manage'"></evaluate-card>
    </div>
  </div>
  <!-- 报名弹出层 -->
  <van-popup v-model="showStu" position="right" class="buyed-users">
    <user-list :userLists="userList"></user-list>
  </van-popup>
  <!-- 预约弹出层 -->
  <van-popup v-model="showQue" position="right" class="buyed-users">
    <user-list :userLists="queueUserList"></user-list>
  </van-popup>
  <!-- 选择教练弹出层 -->
  <van-popup v-model="showCoach" position="right" class="buyed-users">
    <van-radio-group v-model="radio">
      <van-radio checked-color="#4b0" class="buyed-users__box" v-for="(item,index) in coachList" :key="index" :name="item.coachId" @click="checkCoach(item)">
          <div span="22" class="clear buyed-users__item">
            <avatar-box v-if="item.avatar" class="left" :avatar="item.avatar" :auth="item.user.isVip"></avatar-box>
            <avatar-box v-if="item.avatar==''" class="left" :avatar="item.user.largeAvatar" :auth="item.user.isVip"></avatar-box>
            <div class="clear buyed-users__info">
              <div class="clear">
                <div class="left c4 fs2">{{ item.realName }}</div>
              </div>
              <div class="buyed-users__auth mtn fs1 c9">
                <span class="green"> 累计上课{{ item.lessons?item.lessons:0 }}课时</span>
              </div>
            </div>
          </div>
      </van-radio>
    </van-radio-group>
  </van-popup>
  <!-- 选择时间弹出层 -->
  <van-popup v-model="timePopupShow" position="bottom">
      <van-datetime-picker
          type="datetime"
          v-model="currentDate"
          @cancel="timePopupShow = false;"
          @confirm="getTime"/>
  </van-popup>
  <!-- 具体上课时间弹出层 -->
  <input id="weekInput" type="text" value="1" hidden>
  <input id="timedatasInput" type="text" value="" hidden>
  <div id="classTimePopupShow" style="display:none">
    <van-popup v-model="classTimePopupShow" position="bottom" :close-on-click-overlay="false" :lock-scroll="false">      
      <van-picker 
        :columns="timecolumns" 
        show-toolbar
        title="选择开始时间"
        @cancel="popupCancle"
        @confirm="getClassTime"/>
    </van-popup>
  </div>
  <!-- 课程时长弹出层 -->
  <van-popup v-model="showActionsheet" position="bottom">
    <van-picker 
    :columns="columns" 
    show-toolbar
    title="选择课程时长"
    @cancel="onCancel"
    @confirm="onConfirm"/>
  </van-popup>

  <div class="clear bcw buybar">
    <div class="buybar__content clear">
        <van-button type="primary" size="small" class="buybar__btn right mlm" @click="subSave()">保存</van-button>
        <van-button v-if="courseInfo.status != 'published'" type="primary" @click="close(courseInfo.id,'published','确定开课吗？')" size="small" class="buybar__btn right">开课</van-button>
        <van-button v-if="courseInfo.status == 'published'" type="warning" @click="close(courseInfo.id,'closed','是否要下架该课程？')" size="small" class="buybar__btn right">下架</van-button>
    </div>
  </div>
</div>
</template>
<script>
import Vue from 'vue';
import {
  Rate,
  Row,
  Col,
  Popup,Toast,Dialog,RadioGroup,Radio,Cell,CellGroup
} from 'vant';
import TheBuybar from '@/components/TheBuybar'
import EvaluateCard from '@/components/EvaluateCard'
import AvatarBox from '@/components/AvatarBox'
import CoachCard from '@/components/CoachCard'
import AreaList from '@/assets/scripts/area'
import CSelect from "@/components/Select"
import UserList from "@/components/UserList"
import UploadFile from '@/components/UploadFile'
import $ from "jquery";
import MyinitJuicy from "@/assets/drag/js/drag"; //时间段插件
import moment from 'moment'
moment.locale('zh-cn');
Vue.use(Rate).use(Row).use(Col).use(Popup).use(Toast).use(Dialog).use(RadioGroup).use(Radio).use(Cell).use(CellGroup);

export default {
  name: 'CourseItemManage',
  components: {
    TheBuybar,
    EvaluateCard,
    AvatarBox,
    CoachCard,
    CSelect,
    UserList,
    UploadFile
  },
  data() {
    return {
      courseInfo: {},   // 团课
      clubInfo:{},    // 俱乐部
      coachInfo: {
        realName:''
      },  // 教练
      mapUrl:'',  // 导航地图
      arealist: AreaList, // 城市列表
      banners: '',  // 轮播图
      showStu: false, // 学生弹层
      showQue: false, // 排队弹层
      showCoach: false, // 选择教练弹层
      timePopupShow: false, // 时间弹层
      classTimePopupShow:true,
      queueStatus: 0, // 排队状态
      userList: [],  // 已购买用户列表
      userPics:{},  //已购买用户头像
      coachList:[],  //签约教练
      queueUserList:[], //排队列表
      queueUserPics:{},  //排队用户头像
      reviewList:{}, //评价列表
      orderTypes: [
        {
          name: "教练1",
          id: '20'
        },
        {
          name: "教练2",
          address: '黄河三路555号'
        }
      ],
      radio:'', //选择教练的id
      currentDate: new Date(),
      editTime:'', //编辑开课时间
      showActionsheet:false, //课程时长
      timecolumns:[],  //上课时间
      columns: ['1小时', '2小时', '3小时', '4小时'],
      checktime:'',
      isChecked:'',//课程类型选中状态
    }
  },
  created() {      

      // 已购买用户列表
      this.$http.get('club_group_course/getSignUserList?courseId=' + this.$route.params.courseId).then(res => {
        // console.log(res)
        if(!res.data.code){
          this.userList = res.data.value;
        }
      })

      // 排队列表
      this.$http.post('club_group_course_manage/getQueueUserList',{
        id:this.$route.params.courseId
      }).then(res => {
        // console.log(res)
        if(!res.data.code){
          this.queueUserList = res.data.value;
        }
      })
  },
  mounted:function(){
    this.getDataUrl()    
  },
  methods: {
    getDataUrl(){
      // 团课详情
      this.$http.post('club_group_course_manage/getInfo',{
          courseId: this.$route.params.courseId
      }).then(res => {
          console.log(res)      
        if(!res.data.code){
          if(res.data.value.coachInfo != null && res.data.value.coachInfo != ''){
            this.coachInfo = res.data.value.coachInfo   //教练信息
          }
          
          this.courseInfo = res.data.value.courseInfo   //课程信息 
          if(this.courseInfo.about!='' && this.courseInfo.about!=null){
            this.courseInfo.about = res.data.value.courseInfo.about.replace(/<[^>]+>/g,'')  //课程信息
          }
          this.clubInfo = res.data.value.courseInfo.clubInfo  //俱乐部信息
          this.reviewList = res.data.value.reviewList  //评价列表
          this.coachList = res.data.value.signCoachList  //签约教练列表
          this.queueUserPics = res.data.value.queueUserList  //签约学生头像
          this.userPics = res.data.value.signUserList  //学生头像

          if(this.courseInfo.pictures!=''){  //封面
            this.banners = JSON.parse(this.courseInfo.pictures) 
          }

          // $("input[name='type'][value='"+this.courseInfo.type+"']").attr("checked",true);  //设置选中状态
          this.courseInfo.type = this.courseInfo.type.toString()  //数字转换字符串

          if(this.courseInfo.time!=null && this.courseInfo.time!=''){
            $("#timedatasInput").val(JSON.stringify(this.courseInfo.time))
          }
          for (var i = this.clubInfo.businessStartTime; i <= this.clubInfo.businessEndTime; i++) {            
            this.timecolumns.push(i+":00") //弹出时间组件赋值
          }
          this.editTime = moment(this.courseInfo.startTime*1000).format('YYYY-MM-DD HH:mm')
          this.courseInfo.startTime = moment(this.courseInfo.startTime*1000).format('YYYY年MM月DD日, HH:mm')
          this.mapUrl = 'https://apis.map.qq.com/tools/poimarker?type=1&keyword='+window.encodeURIComponent(this.clubInfo.title)+'&center='+ this.clubInfo.latitude + ',' + this.clubInfo.longitude +'&radius=1000&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp'

        }else{
          Toast(res.data.message)
        }

        //渲染时间组件
        this.timeReload($("#timedatasInput").val(),this.clubInfo.businessStartTime,this.clubInfo.businessEndTime)
      })
    },
    timeReload(data,starttime,endtime){
      var $ctm = $('#classTime')
      //渲染时间组件
      $ctm.initJuicy({
        width: $("#classTimeBox").width(),  //宽度
        mondayDate: "2018-01-01",
        timedata: data,  //课程数据
        businessStartTime:starttime,
        businessEndTime: endtime,
        status: false  //不可编辑，仅删除
      },this);

      // 点击时间条,显示弹出层
      $ctm.find(".bar").on('click', function(e) {
        var ele = e.target
        console.log(ele)
        let week = $(ele).attr('id').substring(3)  //当前点击的week
        $("#weekInput").val(week)  //存到input
        $("#classTimePopupShow").show()
        return false;
      })

      //点击绿色时间条，删除
      $ctm.find(".item").on('click', function(e) {
        e.target.remove()
        let newdata = MyinitJuicy.getdata()
        $("#timedatasInput").val(JSON.stringify(newdata))  //存字符串到input  删除后重置一遍timedatas的值
        return false;
      })
    },
    openSmallClass(){
      //开小班
      Dialog.confirm({
          title: '确定开设小班吗？',
      }).then(() => {
          // on confirm 
          this.$http.post('club_group_course_manage/attached',{
              id:this.$route.params.courseId
            }).then(res => {
              console.log(res)
              if(!res.data.code){
                  // this.delStatus = false 
              }else{
                  Toast.fail({
                      message:res.data.message
                  })                        
              }                 
          })
      }).catch(() => {
      // on cancel
      }); 
    },
    close:function(courseId,sta,title){
      //下架  开课
        Dialog.confirm({
            title: title,
        }).then(() => {
        // on confirm  下架
            this.$http.post('club_group_course_manage/edit',{
              id:courseId,
              status:sta
            }).then(res => {
                console.log(res)
                if(!res.data.code){
                    Toast.success('操作成功！')
                    this.courseInfo.status = sta            
                }else{
                    Toast.fail({
                        message:res.data.message
                    })                        
                }                 
            })
        }).catch(() => {
        // on cancel
        });        
    },
    checkCoach(item){
      //选择教练
      console.log(item)
      this.coachInfo.realName = item.realName;
      this.coachInfo.avatar = item.avatar;
      this.coachInfo.lessons = item.lessons;
      this.coachInfo.coachId = item.coachId;
      this.coachInfo.user = item.user;

      this.showCoach = false      
    },
    getTime: function(time){
        // 选择开课时间
        this.editTime = moment(time).format('YYYY-MM-DD HH:mm')
        this.courseInfo.startTime = moment(time).format('YYYY年MM月DD日, HH:mm')
        this.timePopupShow = false;
    },
    getCoverUrl: function(url){
      // 封面照片
      // console.log(url)
      this.courseInfo.picture = url.url;
    },
    getClassTime(time){
      //确定：上课开始时间
      this.checktime = time
      $('#classTimePopupShow').hide()  //第一层弹出关闭
      this.showActionsheet = true  //第二层弹层弹出
    },    
    popupCancle(){
      //取消：上课时间弹层
      $('#classTimePopupShow').hide()
    },
    onConfirm(val){
      //确定：课程时间
      let week = $("#weekInput").val(); //当前点击周
      let timedatas = $("#timedatasInput").val(); //当前数据
      if(timedatas == ''){
        console.log(456)
        timedatas = []
      }else{
        timedatas = JSON.parse(timedatas)  //转为对象
      }
      let sTime = this.checktime.substring(0,this.checktime.length-3);  //开始时间，去掉最后三位字符串 :00
      let pTime = val.substr(0,1);  //时间段
      // console.log('week:'+week)
      // console.log('开始点:'+sTime)
      // console.log('时间段:'+pTime)
      //拼接对象 数组
      let weekday = {};
      weekday['week'] = week;
      weekday['times'] = [];
      for (var i = 0; i < pTime; i++) {
        // console.log(i)
        var startTime = Math.round(sTime) + i;
        var endTime = startTime + 1;
        weekday['times'].push({
            startTime: startTime,
            endTime: endTime
        });
      }
      //console.log(weekday)

      timedatas = timedatas.concat(weekday)
      // console.log(timedatas)
      $("#timedatasInput").val(JSON.stringify(timedatas))  //赋值给input
      //渲染时间组件
      this.timeReload(JSON.stringify(timedatas),this.clubInfo.businessStartTime,this.clubInfo.businessEndTime)
      this.showActionsheet = false
    },
    onCancel(){
      //取消: 课程时间弹层
      this.showActionsheet = false
    },
    subSave(){
      console.log(this.courseInfo.type)
      // console.log($("input[name='type']:checked").val())
      if(!this.courseInfo.title){
        Toast.fail('请填写标题'); return false;
      } 
      if(!this.courseInfo.price){
        Toast.fail('请填写价格'); return false;
      }
      if(!this.coachInfo.coachId){
        Toast.fail('请选择教练'); return false;
      }
      //提交保存、
      if(this.radio==''){  //默认教练id
        this.radio = this.coachInfo.coachId
      }
      this.$http.post('club_group_course_manage/edit',{
          id:this.$route.params.courseId,
          picture:this.courseInfo.picture,
          title:this.courseInfo.title,
          price:this.courseInfo.price,
          about:this.courseInfo.about,
          coachId:this.radio,
          startTime:this.editTime,
          weekNum:this.courseInfo.weekNum,
          type:this.courseInfo.type,
          time:JSON.stringify(MyinitJuicy.getdata())
        }).then(res => {
          console.log(res)
          if(!res.data.code){
              Toast.success('保存成功！')
          }else{
              Toast.fail({
                  message:res.data.message
              })                        
          }                 
      })
    },
  }
}
</script>
<style>
@import "../assets/drag/css/style.css";
</style>
<style lang="less" scoped>
.swipe{
  position: relative;
  height: 1.8rem;
  img{ width: 100%; height: 100%; object-fit: cover; }
  & .uploadBtn.upload-img__box{
    width: 100%;
    height: 100%;
    z-index: 3;
    opacity: 0;
  }
  & .uploadBtn{
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    transform: translate(-50%,-50%);
    -moz-transform: translate(-50%,-50%);
    -o-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
  }
}

.courseitem {
    padding-bottom: 0.7rem;
}
.course-info {
    padding: 0.15rem;
    &__head {
        border-bottom: 0.01rem #f6f6f6 solid;
    }
    &__evaluate {
        line-height: 0.2rem;
        color: #FF6600;
        &>.van-rate{
          margin-right: .1rem;
        }
    }
    &__price {
        font-size: 0.16rem;
        color: #f44;
    }
    &__price:before {
        content: '¥';
        font-size: 0.12rem;
        margin-right: 0.02rem;
    }

    &__enrolled {
        border-bottom: 0.01rem #f6f6f6 solid;
        & > div:first-child {
            line-height: 0.3rem;
        }
        // &__users{
        //     // line-height: .3rem;
    }
    &__avatar {
        float: left;
        width: 0.3rem;
        height: 0.3rem;
        line-height: 0.28rem;
        margin-left: -.05rem;
        background-color: #f6f6f6;
        border-radius: 50%;
        border: 0.02rem solid white;
        text-align: center;
        color: #ddd;
        overflow: hidden;
        & > .iconfont {
            font-size: 0.14rem;
        }
    }
    &__foot {
      &>.address{
        position: relative;
        & .map i{position: absolute;right:0.05rem;top: 50%;margin-top: -0.1rem;font-size: 0.2rem}        
      }      
    }
}
// 教练信息模块
.coach-card {
    &__avatar {
        width: 0.5rem;
        height: 0.5rem;
        line-height: 0.5rem;
        text-align: center;
        background-color: #f6f6f6;
        border-radius: 50%;
        margin-right: 0.15rem;
        overflow: hidden;
    }
    &__info {
        &--auth {
            & > .iconfont {
                font-size: 0.14rem;
                color: #FFA800;
            }
        }
    }
}
.inputbox{
  border: 0;
  background: #f5f5f5;
}
// 已购买者弹出层
.buyed-users {
    &__box {
      display: block;
      border-bottom: 0.01rem #f6f6f6 solid;
      padding: 0.15rem;
    }
    width: 80%;
    height: 100%;
    &__item {
      display: block;
      width: 100%;
    }
    &__info {
        overflow: hidden;
    }
}
@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .buybar {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/CourseItemManage.vue